import { UxStateEnum, UxStatusEnum } from "@imaginelearning/mps-ux-component-library";

export interface DefaultAction {
  status: UxStatusEnum;
  state: UxStateEnum;
  content: {
    title: string;
    state: UxStateEnum;
    action: {
      text: string;
      enabled: boolean;
      callback: any;
    };
  };
}

const defaultAction = {
  status: UxStatusEnum.LOADING,
  state: UxStateEnum.LOCKED,
  content: {
    title: "",
    state: UxStateEnum.LOCKED,
    action: {
      text: "",
      enabled: false,
      callback: null
    }
  }
};

export default defaultAction;
